import { render, staticRenderFns } from "./NovelGame.vue?vue&type=template&id=49030400&scoped=true&"
import script from "./NovelGame.vue?vue&type=script&lang=js&"
export * from "./NovelGame.vue?vue&type=script&lang=js&"
import style0 from "./NovelGame.vue?vue&type=style&index=0&id=49030400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49030400",
  null
  
)

export default component.exports